import React from "react";
import BoxPlotComponent from "./base/boxPlot";
import DonutChartComponent from "./base/donutChart";
import { BoxPlotData, DonutChartData } from "./types";

interface ExperimentalOverviewSectionProps {
  cargoData: DonutChartData[];
  cargoTypeData: DonutChartData[];
  methodData: DonutChartData[];
  routeData: DonutChartData[];
  targetData: DonutChartData[];
  typeData: DonutChartData[];
  batchingData: DonutChartData[];
  mixingData: DonutChartData[];
  boxPlotData: BoxPlotData[];
}

const ExperimentalOverviewSection: React.FC<
  ExperimentalOverviewSectionProps
> = ({
  cargoData,
  cargoTypeData,
  methodData,
  routeData,
  targetData,
  typeData,
  batchingData,
  mixingData,
  boxPlotData,
}) => {
  return (
    <div className="mb-8 bg-white rounded-lg shadow-md">
      <div className="p-4 border-b border-gray-200">
        <h2 className="text-xl font-semibold text-gray-800">Experiments</h2>
      </div>
      <div className="p-4">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div>
            <DonutChartComponent data={cargoData} title="Cargo" height={400} />
          </div>
          <div>
            <DonutChartComponent
              data={cargoTypeData}
              title="Cargo Type"
              height={400}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 mt-6 md:grid-cols-2">
          <div>
            <DonutChartComponent
              data={methodData}
              title="Readout Method"
              height={400}
            />
          </div>
          <div>
            <DonutChartComponent
              data={routeData}
              title="Route of Administration"
              height={400}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 mt-6 md:grid-cols-2">
          <div>
            <DonutChartComponent
              data={targetData}
              title="Delivery Target"
              height={400}
            />
          </div>
          <div>
            <DonutChartComponent
              data={typeData}
              title="Delivery Target Type"
              height={400}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 mt-6 md:grid-cols-2">
          <div>
            <DonutChartComponent
              data={batchingData}
              title="Batching Method"
              height={400}
            />
          </div>
          <div>
            <DonutChartComponent
              data={mixingData}
              title="Preparation Method"
              height={400}
            />
          </div>
        </div>

        <div className="mt-8">
          <BoxPlotComponent
            data={boxPlotData}
            title="Experiment Value By Library ID"
            xAxisLabel="Library ID"
            yAxisLabel="Experimental Value (Z-score)"
            height={500}
            boxColors={{
              fill: "#b3c6ff80",
              stroke: "#8884d8",
              medianStroke: "#4834cb",
              whiskerStroke: "#8884d8",
              outliersColor: "#ff7300",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ExperimentalOverviewSection;
